
export default {
  name: 'AppControllerSportsbook',
  values: {
    interactionEvents: [
      'touchmove',
      'scroll',
      'mojito_button_click',
    ],
  },
  meta: {
    extendable: false,
  },
}
